import React from 'react'

import { useTheme } from 'styled-components/native'

import {
  isCaregiverSessionType,
  isGroupSessionType,
  LTSessionTypes,
} from '@lyrahealth-inc/shared-app-logic/src/features/sessions/constants'

import { IconBadge } from '../../atoms/iconBadge/IconBadge'
import { CaregiverSessionIcon } from '../../atoms/icons/CaregiverSessionIcon'
import { FamilySessionIcon } from '../../atoms/icons/FamilySessionIcon'
import { TeenSessionIcon } from '../../atoms/icons/TeenSessionIcon'
import { BadgeShape } from '../../badge/constants'
import { tID } from '../../utils/utils'

type DBTTeensSessionTypeIconProps = {
  sessionType?: string | null
}

const BADGE_STYLE = {
  height: 48,
  width: 48,
  paddingVertical: 0,
  paddingLeft: 0,
  paddingRight: 0,
  borderWidth: 2,
}

export const DBTTeensSessionTypeIcon: React.FC<DBTTeensSessionTypeIconProps> = ({ sessionType }) => {
  const { colors } = useTheme()
  const { teenSession, familySession, caregiverSession, borderColor } = colors.components.sessionTypeIconBadge

  // The icons must carry their own fillColor: IconBadge only falls back to the badge variant's
  // foreground when the icon element does not supply one.
  const badge = isCaregiverSessionType(sessionType)
    ? {
        background: caregiverSession.background,
        icon: <CaregiverSessionIcon fillColor={caregiverSession.text} />,
        iconSize: 24,
      }
    : sessionType === LTSessionTypes.DBT_TEENS_FAMILY_SESSION || isGroupSessionType(sessionType)
      ? {
          background: familySession.background,
          icon: <FamilySessionIcon fillColor={familySession.text} />,
          iconSize: 24,
        }
      : { background: teenSession.background, icon: <TeenSessionIcon fillColor={teenSession.text} />, iconSize: 20 }

  return (
    <IconBadge
      testID={tID(`DBTTeensSessionTypeIcon-${sessionType}`)}
      backgroundColor={badge.background}
      frontIcon={badge.icon}
      frontIconSize={badge.iconSize}
      shape={BadgeShape.ROUND}
      style={{ ...BADGE_STYLE, borderColor }}
    />
  )
}
